<!--新增坏件单-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256"
  >
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="200">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td width="60">&nbsp;</td>
          <td align="right" >总数:{{totalnumber}}</td>
          <td align="right" width="60"></td>
          <td align="right" width="60"></td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedcode" :show-overflow-tooltip="true"
                label="编码"
                align="center"
                width="130"
                header-align="center">
              </el-table-column>
              <el-table-column
              prop="seedname" :show-overflow-tooltip="true"
              label="名称"
              align="center"
              header-align="center">
              </el-table-column>
              <el-table-column v-if="this.addtype=='frame'"
                prop="model"
                label="型号"
                width="120"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column v-if="this.addtype=='frame'"
                prop="color"
                label="色号"
                width="80"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column v-if="this.addtype=='len'"
                               prop="type"
                               label="R/L"
                               width="60"
                               align="center"
                               header-align="center">
              </el-table-column>
              <el-table-column v-if="this.addtype=='len'"
                               prop="Y"
                               label="球镜"
                               width="80"
                               align="center"
                               header-align="center">
              </el-table-column>
              <el-table-column v-if="this.addtype=='len'"
                               prop="X"
                               label="柱镜"
                               width="80"
                               align="center"
                               header-align="center">
              </el-table-column>
              <el-table-column
                prop="storegoodsbarcode"
                label="唯一码"
                width="150"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="starttime"
                label="批次号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="endtime"
                label="有效期"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 60px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveDataZyanj" :loading="loading">确认</el-button>
      <el-input style="width: 130px" ref="inputScan" size="small" v-model="storegoodsbarcode" placeholder="扫唯一码"  onfocus="this.select()"  @keyup.enter.native="getZyanjingQRCode()"></el-input>
    </div>
  </el-dialog>
</template>


<script>
  import {getRemark} from '@/plugin/ordercommon'
  import {addstoragebad} from '@/api/set/warehouse'
  import {getListData,cusandptbyind} from '@/api/set/jxcstore'
  import {getQRCode,updateouttime as updateQRouttime,checkBars} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: 'AddStorageBadQRCode',
    msg:'仓库岗 添加坏件（供应商多发、正式库转入）扫码',
    data() {
      return {
        dialogFormVisible: false,
        storegoodsbarcode:'',
        totalnumber:0,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        remark: '',
        pcustomerserial:'',
        cangkucode: '',
        cangkuname: '',
        cangkucodes: [],
        pingpainame:'',
        tableData: [],
        addtype:1,
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        storenumtable: [],
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        num: 0,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo:"",
        },
        loading: false,
        seedcodeData:[]
      }

    },
    methods: {
      getZyanjingQRCode() {//平台自己生成的二维码
        if(!this.storegoodsbarcode)
          return;
        this.storegoodsbarcode = this.storegoodsbarcode.replace(/……/g, '^');
        var qrcodeLen = this.storegoodsbarcode.split('^');
        var qrcode = qrcodeLen[qrcodeLen.length - 1]
        this.storegoodsbarcode = '';
        getQRCode({storegoodsbarcode: qrcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.used == 1) {
              this.errorAlert('商品【' + qrcode + '】已出库：' + arr.outordernum + '！');
              return;
            }
            if (this.controlData.cangkucode != arr.cangkucode) {
              this.errorAlert('商品【' + qrcode + '】所属仓库不正确！');
              return;
            }

            var pipei = null;
            for (let j in this.tableData) {
              if (this.tableData[j].storegoodsbarcode == qrcode) {
                this.error('重复扫码【' + qrcode + '】！')
                return;
              }
            }
            var item = {
              seedcode: arr.seedcode,
              seedname: arr.seedname,
              packagesize: arr.packagesize,
              P: 1,
              storegoodsbarcode:arr.storegoodsbarcode,
              starttime: this.formatDate(arr.starttime),
              endtime: this.formatDate(arr.endtime),
            };
            var pg = {};
            if (arr.packagesize) pg = JSON.parse(arr.packagesize);
            if (pg.M) {
              item["model"] = pg.M;
              item["color"] = pg.C;
            } else if (pg.X) {
              item["X"] = pg.X;
              item["Y"] = pg.Y;
              if(pg.type){
                item["type"] = pg.type;
              }
            }
            this.tableData.push(item);
            this.totalNumber(1);
          } else {
            this.errorAlert('条码【' + qrcode + '】不存在！')
          }
        });
      },
      setTimeZero(value) {
        return value > 9 ? value : '0' + value;
      },
      formatDate(date) {
        if (!date)
          return '';
        var myDate = new Date(date);
        return this.setTimeZero(myDate.getFullYear()) + '-'+(this.setTimeZero(myDate.getMonth() + 1)) + '-' + this.setTimeZero(myDate.getDate());
      },
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      //购买总数
      totalNumber(num) {
        if (!this.totalnumber)
          this.totalnumber = 0
        this.totalnumber += num;
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber(-1)
      },
      //获得标题
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        this.tableData=[];
      },
      saveDataZyanj() {//找眼镜自己的码出库
        var codes = ''
        var arr=[]
        this.loading = true
        for (let i in this.tableData) {
          var store = this.tableData[i].storegoodsbarcode;
          if (store) {
            if ((';' + codes).indexOf(';' + store + ';') > -1) {
              this.error('条码【' + store + '】重复！')
              this.loading = false
              return
            }
            codes += store + ";";
            var hasvalue = false;
            for (let j in arr) {
              if (arr[j].seedcode == this.tableData[i].seedcode && arr[j].packagesize == this.tableData[i].packagesize) {
                arr[j].P = parseInt(arr[j].P) + 1
                hasvalue = true;
              }
            }
            if (!hasvalue) {
              this.tableData[i].P = 1;
              arr.push(this.tableData[i]);
            }
          }
        }

        if (codes == '') {
          this.error('缺失条码数据！')
          this.loading = false
          return
        }
        checkBars({storegoodsbarcodes:codes}).then(response=>{//先检查唯一码是否存在
          if (response.data.code == 0) {//检查成功
            this.saveData(arr,codes);
          }else{
            this.error(response.data.msg)
            this.loading=false;
          }
        });
      },
      errorAlert(msg){
        this.$alert(msg, '异常', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
            this.$refs.inputScan.focus();
          }
        });
      },
      saveData(arr,needsaveQRCode) {
        if (arr.length == 0) {
          this.error('缺失条码数据！')
          this.loading = false;
          return;
        }
        addstoragebad({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify({
            pcustomerserial: '',
            pcustomer: '',
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            address: '',
            linkman: '',
            linkmantel: '',
            seedcode: arr[0].seedcode,
            seedname: arr[0].seedname,
            remark: this.controlData.remark,
            tracknum: '',
            logisticstracknum: '',
            addtype: 2,//正式转入
          })
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            updateQRouttime({
              storegoodsbarcodes: needsaveQRCode,
              outordernum: response.data.erpserial
            }).then(response => {});

            this.$emit('bindGrid');
            this.$emit('openDetail', {
              erpserial: response.data.erpserial,
              seedcode: arr[0].seedcode,
              seedname: arr[0].seedname,
              cangkucode: this.controlData.cangkucode,
              filltemplate: this.filltemplate || ''
            });
          } else {
            this.error(response.data.msg)
            this.loading = false;
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      initData(type) {
        this.addtype=type;//len 镜片，frame 镜架
        this.initForm()
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
          this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
        }
        this.$nextTick(() => {
          this.$refs.inputScan.focus();
        })
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.controlData = {}
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.index = -99
        this.form.seedcode = ''
        this.form.seedname = ''
        this.num = 0;
        this.loading = false
      }
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
      })
    },

    components: {
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AddStorageBadQRcode.vue